<template>
  <v-layout row>
    <v-layout
      align-end
      class="my-2"
    >
      <v-flex xs4>
        <app-reference
          v-model="entity.unloadingCountry"
          :outline="true"
          class="mx-2 my-0"
          label="Страна прибытия"
          :height-field="44"
          resource="countries"
          component-name="Country"
        />
      </v-flex>
      <v-flex xs4>
        <app-reference
          v-model="entity.unloadingFactory"
          :outline="true"
          class="mx-2 my-0"
          label="Продавец"
          resource="factories"
          component-name="Factory"
          parent-filter="countryId"
          :parent-id="entity.unloadingCountry ? entity.unloadingCountry.id : 0"
          :height-field="44"
        />
      </v-flex>
      <v-flex xs4>
        <LoadingPlaceReference
          v-model="entity.unloadingAddress"
          label="Адрес места прибытия"
          :entity="entity"
          :factory-id="entity.unloadingFactory ? entity.unloadingFactory.id : 0"
          class="mx-2 my-0"
        />
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import LoadingPlaceReference from "./LoadingPlaceReference.vue";

export default {
  components: {
    LoadingPlaceReference,
  },
  props: ["entity"],
};
</script>
